import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup, B2cCopyModal, FileViewerModal} from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Row, Col, Popconfirm, Upload, Space, message } from 'antd';
import { useB2cDetail } from 'hooks';
import { Lecture, LecturePlaceB2c, RangePicker, LectureWeek, NotionUrl, Pm } from 'components/atoms'
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';
import moment, { Moment } from 'moment';
import { getCodeNumberArray } from 'utils/form-utils';
import { isEmpty } from 'utils/utils';
import { usePopupManager } from 'react-popup-manager';
import { UploadFile } from 'antd/lib/upload/interface';
import { isFileViewer } from 'utils/file-utils';
import { UploadOutlined, CloseOutlined, PaperClipOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { IMaskInput } from "react-imask";

export interface FileInfoType {
    fileid: number, 
    filename: string    
}

export interface B2cEditModalProps extends PopupProps {
    id: number;
}

const B2cEditModal = ({ 
    isOpen, 
    onClose, 
    id}: B2cEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const [lectureOpt, setLectureOpt] = useState<LectureCodeListDto>();
    const [mapFileList, setMapFileList] = useState<UploadFile[]>([]);
    const [mapFile, setMapFile] = useState<FileInfoType>({fileid: 0, filename: ''});  
    const [otFileList, setOtFileList] = useState<UploadFile[]>([]);
    const [otFile, setOtFile] = useState<FileInfoType>({fileid: 0, filename: ''});     
    const [margin, setMargin] = useState<string>('0 (0%)');
    const [max_price, setMax_price] = useState<number>(0);
    const [lecturer_in_price, setLecturer_in_price] = useState<number>(0);
    const [lecturer_out_price, setLecturer_out_price] = useState<number>(0);
    const [place_price, setPlace_price] = useState<number>(0);
    const [print_price, setPrint_price] = useState<number>(0);
    const [etc_price, setEtc_price] = useState<number>(0);   
    const [closeYn, setCloseYn] = useState<string>('N');  
    const [submittable, setSubmittable] = React.useState(false);
  /* ======================================================
  * hooks
  * ====================================================== */
 const onIsClose = (isOk) => {
    if (isOk) setCloseYn(closeYn==='Y'?'N':'Y')
 }
  const { b2cInfo, insertSuccess, updateSuccess, deleteSuccess, closeSuccess, dropSuccess, b2cInsert, b2cUpdate, b2cClose, b2cDelete, b2cDrop } = useB2cDetail(id, onIsClose);
  {(id>0)?(b2cInfo?.lecture_cha):(lectureOpt?.cha)}
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { open } = usePopupManager();  

  const configBlocks = {
    PriceInput: {
      mask: Number,
      signed: true,  // disallow negative
      thousandsSeparator: ",",  // any single char
      padFractionalZeros: false,
      normalizeZeros: false,
      unmask: true // true|false|'typed'
    }
  }  
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(closeSuccess);
    };

    const onCopy = () => {
        open(B2cCopyModal, {id: id, onClose: (isOk)=>{if(isOk) {onClose?.(true)}}});         
    };

    const onSubmit = (e) => {
        if (id > 0) {
            b2cUpdate({
                id: id,
                start_date: startDate,
                end_date: endDate,             
                student_max: e.student_max,
                repeat_week: e.repeat_week,                
                week_mon: Number(e.week_mon), 
                week_tue: Number(e.week_tue),
                week_wed: Number(e.week_wed), 
                week_thu: Number(e.week_thu), 
                week_fri: Number(e.week_fri), 
                lecture_place_type: b2cInfo?.lecture_place_type,
                lecture_studio: e.lecture_studio,
                location: e.location,         
                notion_url: e.notion_url,       
                pm: e.pm,
                need_operater_yn: e.need_operater_yn?'Y':'N',
                need_operater_num: e.need_operater_num,
                lecturer_in_price: lecturer_in_price,
                place_price: place_price,
                print_price: print_price,
                etc_price: etc_price,   
                expect_price: Number(form.getFieldValue('expect_price').toString().replaceAll(',','')) | 0,                             
                memo: e.memo,
                map_fileData: mapFileList.map((file) => file.originFileObj),
                ot_fileData: otFileList.map((file) => file.originFileObj),
                map_file_id: mapFile.fileid,
                ot_file_id: otFile.fileid,
                lecture_cha: e.lecture_cha,
                lecture_gid: b2cInfo?.lecture_gid,
            })  
        } else if (!!lectureOpt) {
            b2cInsert({
                id: id,
                lecture_gid: Number(lectureOpt.value),
                lecture_cha: e.lecture_cha,
                lecture_price: lectureOpt.price,
                lecture_sale_yn: lectureOpt.sale_yn,
                lecture_place_type: lectureOpt.online_yn === 'Y'? 'ONLINE': 'OFFLINE',
                start_date: startDate,
                end_date: endDate,             
                student_max: e.student_max,
                repeat_week: e.repeat_week,                
                week_mon: Number(e.week_mon || false), 
                week_tue: Number(e.week_tue || false),
                week_wed: Number(e.week_wed || false), 
                week_thu: Number(e.week_thu || false), 
                week_fri: Number(e.week_fri || false), 
                lecture_studio: e.lecture_studio,
                location: e.location,         
                notion_url: e.notion_url,       
                pm: e.pm,
                need_operater_yn: e.need_operater_yn?'Y':'N',
                need_operater_num: e.need_operater_num,
                lecturer_in_price: lecturer_in_price,
                place_price: place_price,
                print_price: print_price,
                etc_price: etc_price,                 
                memo: e.memo,
                map_fileData: mapFileList.map((file) => file.originFileObj),
                ot_fileData: otFileList.map((file) => file.originFileObj),
                map_file_id: mapFile.fileid,
                ot_file_id: otFile.fileid,     
                expect_price: Number(form.getFieldValue('expect_price').toString().replaceAll(',','')) | 0,         
            })  
        }
    };

    const calcMargin = () => {
        if (max_price > 0) {
            const calc = max_price - lecturer_in_price - lecturer_out_price - place_price - print_price - etc_price;
            const str = calc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            const per  = ((calc / max_price)*100).toFixed(0);
            setMargin(str+'('+per+'%)');
        }
    }

    const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
   
        const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYY-MM-DD') : undefined;
        const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYY-MM-DD') : undefined;
    
        setStartDate(searchDateS);
        setEndDate(searchDateE);
      };

    const onSelectLectur = (opt: LectureCodeListDto) => {
        setLectureOpt(opt)        
        form.setFieldValue("lecture_cha", opt.cha);
    }      


    const onDownload = (fileSeq:number, fileName: string): void => {

        axios({
          url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
          method: 'get',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
          });
        };
    
        const onOpenFileViewer = (fileId: number, fileName: string) => {
          open(FileViewerModal, {
            fileid: fileId,
            filename: fileName,
            seq: 0,
            gubun: '',
            editable: false,
            onClose: (isOk) => {
              if (isOk) {
                
              };
            },
          }); 
         }    
             
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!b2cInfo) {            
            if (!!b2cInfo.start_date && b2cInfo.start_date !== '0000-00-00' && !!b2cInfo.end_date && b2cInfo.end_date !== '0000-00-00') {
                setStartDate(b2cInfo.start_date);
                setEndDate(b2cInfo.end_date);
            }               
            form.setFieldsValue({
                lecture_gid: b2cInfo.lecture_gid || undefined, 
                repeat_week: b2cInfo.repeat_week || 0,
                student_max: b2cInfo.student_max || 0,
                project_date: (!!b2cInfo.start_date && b2cInfo.start_date !== '0000-00-00' && !!b2cInfo.end_date && b2cInfo.end_date !== '0000-00-00')?[moment(b2cInfo.start_date, "YYYY-MM-DD"), moment(b2cInfo.end_date, "YYYY-MM-DD")]:[], 
                week_mon: b2cInfo.week_mon, 
                week_tue: b2cInfo.week_tue,
                week_wed: b2cInfo.week_wed, 
                week_thu: b2cInfo.week_thu, 
                week_fri: b2cInfo.week_fri, 
                lecture_place_type: b2cInfo.lecture_place_type?b2cInfo.lecture_place_type:lectureOpt?.online_yn==='Y'?'ONLINE':'OFFLINE',
                lecture_studio: b2cInfo.lecture_studio,
                location: b2cInfo.location,         
                notion_url: b2cInfo.notion_url,       
                pm: getCodeNumberArray(b2cInfo.pm),
                need_operater_yn: (b2cInfo.need_operater_yn==='Y')?true:false,
                need_operater_num: b2cInfo.need_operater_num,
                lecturer_in_price: b2cInfo.lecturer_in_price || 0,
                place_price: b2cInfo.place_price || 0,
                print_price: b2cInfo.print_price || 0,
                etc_price: b2cInfo.etc_price || 0,                
                memo: b2cInfo.memo || '',
                lecture_cha: b2cInfo.lecture_cha,
                expect_price: b2cInfo.expect_price || 0,
            });

            if (!!b2cInfo.map_file_id && b2cInfo.map_file_name)
                setMapFile({fileid: b2cInfo.map_file_id, filename: b2cInfo.map_file_name});
            if (!!b2cInfo.ot_file_id && b2cInfo.ot_file_name)
                setOtFile({fileid: b2cInfo.ot_file_id, filename: b2cInfo.ot_file_name});

            setMax_price(b2cInfo.max_price);
            setLecturer_in_price(b2cInfo.lecturer_in_price);
            setLecturer_out_price(b2cInfo.lecturer_out_price);
            setPlace_price(b2cInfo.place_price);
            setPrint_price(b2cInfo.print_price);
            setEtc_price(b2cInfo.etc_price);
            setCloseYn(b2cInfo.close_yn);

            calcMargin();                

        }
    }, [b2cInfo])

    useEffect(() => {
        form.setFieldsValue({
            lecturer_in_price: 0,
            place_price: 0,
            print_price: 0,
            etc_price: 0,                
            expect_price: 0,
        });
    }, [])

    useEffect(() => {
        if (insertSuccess || updateSuccess || deleteSuccess || dropSuccess) {
            onClose?.(true);  
        }
    }, [insertSuccess, updateSuccess, deleteSuccess, dropSuccess])

    useEffect(() => {
        calcMargin();
    }, [max_price,lecturer_in_price,lecturer_out_price,place_price,print_price,etc_price])    

    const values = Form.useWatch([], form);
    useEffect(() => {
        form.validateFields({ validateOnly: true }).then(
            () => {
              setSubmittable(true);
            },
            () => {
              setSubmittable(false);
            },
          );
    }, [values])

    return (
    <>
        <ModalWrapper open={isOpen} onCancel={onCancel} width={650} title={id===0?'공개과정 등록':'공개과정 수정'} closable>
            <Form
                form={form}
                name="B2cInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={15}>
                        <Form.Item name="lecture_gid" label={'과정'} rules={[{ required: true, message: '' }]}>
                            <Lecture form={form} onSelected={onSelectLectur} disable={id>0} />
                        </Form.Item> 
                    </Col> 
                    <Col span={9}> 
                        <Form.Item name="lecture_cha" label={'회차'}>
                            <Input type="number" /> 
                        </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={15}>
                        <Form.Item label={'금액'}>
                            {(id>0 && b2cInfo && b2cInfo.lecture_price)?(b2cInfo.lecture_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")):(lectureOpt)?(lectureOpt?.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")):'0'}
                        </Form.Item>                          
                    </Col> 
                    <Col span={9}> 
                        <Form.Item label={'할인여부'}>
                            {(id>0)?(b2cInfo?.lecture_sale_yn):(lectureOpt?.sale_yn)}
                        </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={15}>
                        <Form.Item name="project_date" label={'교육 기간'} rules={[{ type: 'array' as const, required: true, message: '' }]}>
                            <RangePicker format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} />                                   
                        </Form.Item>  
                    </Col> 
                    <Col span={9}> 
                        <Form.Item name="student_max" label={'최대교육인원'}>
                            <Input type='number' />
                        </Form.Item>   
                    </Col>            
                </Row>    
                <Form.Item label={'교육 일정'}>
                    <LectureWeek form={form} />
                </Form.Item>                             
                <Form.Item label={'교육 장소'}>
                    <LecturePlaceB2c  form={form} lecture_place_type={(id>0)?b2cInfo?.lecture_place_type||'OFFLINE':lectureOpt?.online_yn==='Y'?'ONLINE':'OFFLINE'} lecture_studio={b2cInfo?.lecture_studio || ''} />
                </Form.Item> 
                {/*
                <Form.Item label={'강의요청서'}>
                    <NotionUrl form={form} url={b2cInfo?.notion_url || ''} />   
                </Form.Item>                
                */}
                <Form.Item label={'PM'}>
                    <Pm fieldname={'pm'} pm={b2cInfo?.pm} />   
                </Form.Item>    
                <Form.Item name="expect_price" label={'예상매출'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('expect_price', value);})}/>
                </Form.Item>                   
                <Form.Item label={'매출'}>
                    <label>{b2cInfo?.max_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}&nbsp;&nbsp;&nbsp;매출이익 : {margin}&nbsp;&nbsp;&nbsp;시간당단가 : {b2cInfo?.time_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label> 
                </Form.Item> 
                <Form.Item name='lecturer_in_price' label={'내부강사료'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('lecturer_in_price', value);setLecturer_in_price(Number(value));})}/>
                </Form.Item>
                <Form.Item label={'외부강사료'}>
                    <label>{b2cInfo?.lecturer_out_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>                    
                </Form.Item>
                <Form.Item name='place_price' label={'교육장(식사,다과포함)'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('place_price', value);setPlace_price(Number(value));})}/>
                </Form.Item>   
                <Form.Item name='print_price' label={'인쇄비'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('print_price', value);setPrint_price(Number(value));})}/>
                </Form.Item>   
                <Form.Item name='etc_price' label={'기타비용'}>
                <IMaskInput blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('etc_price', value);setEtc_price(Number(value));})}/>
                </Form.Item>                  
                <Form.Item name='memo' label={'메모'}>
                    <TextArea rows={3} placeholder='메모를 입력하세요'/>   
                </Form.Item>
                <Form.Item name="map_file_id" label={'지도'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={mapFileList}
                            onChange={({ fileList: list }) => {
                                setMapFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".ppt,.pptx,.pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                            disabled={mapFile.fileid > 0}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {(mapFile.fileid > 0) && (
                            <Space key={mapFile.fileid}>
                                <Button onClick={()=>{onDownload(mapFile.fileid, mapFile.filename)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(mapFile.filename) && (<Button onClick={()=>{onOpenFileViewer(mapFile.fileid, mapFile.filename)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   

                                {mapFile.filename}
                                <CloseOutlined
                                    style={{ fontSize: 12, color: '#b9b9b9' }}
                                    onClick={() => {
                                        setMapFile({fileid:0, filename:''});
                                    }}
                                />
                            </Space>
                        )} 
                        {mapFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setMapFileList(mapFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                        
                </Form.Item>                  
                <Form.Item name="ot_file_id" label={'OT 데이터'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={otFileList}
                            onChange={({ fileList: list }) => {
                                setOtFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".ppt,.pptx,.pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                            disabled={otFile.fileid > 0}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {(otFile.fileid > 0) && (
                            <Space key={otFile.fileid}>
                                <Button onClick={()=>{onDownload(otFile.fileid, otFile.filename)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(otFile.filename) && (<Button onClick={()=>{onOpenFileViewer(otFile.fileid, otFile.filename)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   

                                {otFile.filename}
                                <CloseOutlined
                                    style={{ fontSize: 12, color: '#b9b9b9' }}
                                    onClick={() => {
                                        setOtFile({fileid:0, filename:''});
                                    }}
                                />
                            </Space>
                        )} 
                        {otFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setOtFileList(otFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                       
                </Form.Item>                        
                {(id>0) && (
                <Form.Item label={'모집중/마감'}>
                    <Popconfirm
                        title={closeYn==='Y'?'모집중 상태로 변경 하시겠습니까?':'마감 상태로 변경 하시겠습니까?'} 
                        okText={closeYn==='Y'?'모집중':'마감'} 
                        cancelText="취소"
                        onConfirm={() => { b2cClose({id:id, close_yn:closeYn==='Y'?'N':'Y'})}}
                    >   
                        <Button>{closeYn==='Y'?'마감':'모집중'}</Button>
                    </Popconfirm>
                </Form.Item>                                 
                )}      
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCancel} style={{marginRight: "5px"}}>닫기</Button>
                        {(id>0) && (<Button onClick={onCopy}>복사</Button>)}
                    </div>   
                    <div>
                        {(id>0 && !!b2cInfo && b2cInfo.bill_price === 0 && b2cInfo.status_type === 'AV') && (
                            <>
                            <Popconfirm
                                title="삭제 하시겠습니까?"
                                okText="삭제"
                                cancelText="취소"
                                onConfirm={() => { b2cDelete({id:id})}}
                            >   
                                <Button danger style={{marginRight: "5px"}}>삭제</Button>        
                            </Popconfirm>
                            <Popconfirm
                                title="폐강 하시겠습니까? 폐강 처리시 스케줄은 삭제됩니다."
                                okText="폐강"
                                cancelText="취소"
                                onConfirm={() => { b2cDrop({id:id})}}
                            >   
                                <Button danger style={{marginRight: "5px"}}>폐강</Button>        
                            </Popconfirm>                            
                            </>
                        )}
                        <Button onClick={()=>{submittable?form.submit():alert("필수정보를 입력하지 않았습니다")}}  type="primary">{id===0?'등록':'수정'}</Button>
                    </div>
                </ButtonGroup>                
            </Form>            
        </ModalWrapper>  
    </>
    )    
};

export default React.memo(B2cEditModal);    